module.exports = __webpack_public_path__ + "static/media/SyriaMap.fad84a4f.png";